import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';

import styles from './mfa-flash-banner.module.css';

export function MfaFlashBanner() {
    return (
        <FlashBanner type='info' hasBorder={true} noRightPadding={true} animate={false}>
            <div className='full-width flex justify-sb'>
                <div>
                    Enable two-factor authentication on your own account before requiring it for all
                    users.
                </div>
                <div className={styles['mfa-flash-banner-cta-container']}>
                    <Link variant='primary' newTab={true} href='/my-account/settings'>
                        Go to profile
                    </Link>
                </div>
            </div>
        </FlashBanner>
    );
}
